import { ISetting } from './../../../_models/cms/ISetting';
import { SettingService } from './../../../shared/services/setting.service';
import { AllotmentService } from './../../../management/services/allotment.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-merit',
  templateUrl: './employee-merit.component.html',
  styleUrls: ['./employee-merit.component.css']
})
export class EmployeeMeritComponent implements OnInit {

  skeleton: boolean = true;
  loading: boolean;
  title: string = 'Round-I';
  employeeMerit: any;
  setting: ISetting;

  constructor(
    private service: AllotmentService,
    private settingService: SettingService,) { }

  async ngOnInit() {
    this.setting = await this.settingService.getSetting();
    this.getAllotment();
  }

  private getAllotment() {
    this.service.getLogged().subscribe((response: any) => {
      if (response) {
        this.employeeMerit = response;
      }
    },
      (error) => console.log('HTTP Error', error),
      () => this.skeleton = false);
  }

  get isAllowedSecondRound(): boolean {
    return this.employeeMerit ? !((this.employeeMerit.transferCategoryId != 7 && this.employeeMerit.schoolId) || (this.employeeMerit.transferCategoryId != 7 && this.employeeMerit.isTransfer == false)) : false;
  }
}
